const dev = {
  api: {
    url: 'http://localhost:3001',
  },
  featureToggle: true,
  termsCondsLink: 'https://www.alliantenergy.com/more/termsprivacyandaccessibility/termsofuse',
  sessionTimeout: 300, // in seconds
  fixedBillPlanURL: 'https://www.alliantenergy.com/accountandbilling/payingyourbill/fixedamountbill',
  e2eURL: 'http://localhost:3000/',
};

const qa = {
  api: {
    url: 'https://rateswitchqa-api.alliantenergy.com',
  },
  featureToggle: true,
  termsCondsLink: 'https://www.alliantenergy.com/more/termsprivacyandaccessibility/termsofuse',
  sessionTimeout: 300, // in seconds
  fixedBillPlanURL: 'https://www.alliantenergy.com/accountandbilling/payingyourbill/fixedamountbill',
  e2eURL: 'https://rateswitchqa.alliantenergy.com/',
};

const prod = {
  api: {
    url: 'https://rateswitch-api.alliantenergy.com',
  },
  featureToggle: false,
  termsCondsLink: 'https://www.alliantenergy.com/more/termsprivacyandaccessibility/termsofuse',
  sessionTimeout: 300, // in seconds
  fixedBillPlanURL: 'https://www.alliantenergy.com/accountandbilling/payingyourbill/fixedamountbill',
  e2eURL: 'https://rateswitchqa.alliantenergy.com/',
};

const common = {
  gtmId: 'GTM-P4D9XW6',
};

let config = dev;

switch (process.env.REACT_APP_ENV) {
  case 'qa':
    config = qa;
    break;
  case 'prod':
    config = prod;
    break;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...common,
  ...config,
};
